import { useIdleTimer } from 'react-idle-timer'

const THIRTY_MINS = 1_800_000

const useIdleRefresh = () => {
  // After 30 minutes of inactivity
  const handleOnIdle = () => {
    // TODO(mkramerl): Inject the DataLoadManager to refresh the data.
  }

  // When the user begins interacting again after 30 minutes has passed
  const handleOnActive = () => {
    // TODO(mkramerl): Inject the DataLoadManager to refresh the data.
  }

  useIdleTimer({
    timeout: THIRTY_MINS,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    debounce: 500,
  })
}

export default useIdleRefresh
